var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer-wrap"},[_c('div',{staticClass:"timer-content"},[_c('span',[_vm._v(_vm._s(_vm.formattedTime.project))])]),_c('span',{staticClass:"timer-total"},[_vm._v(" Total today: "+_vm._s(_vm.formattedTime.total)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }